import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

function SortableHeaderContent({ label, sortable = false, direction = null }) {
    if (!sortable) {
        return label;
    }

    const rootClassName = ["oct_sortable-header", direction ? `is-${direction}` : ""]
        .filter(Boolean)
        .join(" ");

    let icon = null;
    if (direction === "asc") {
        icon = <ArrowDown className="oct_sortable-header__icon" aria-hidden="true" />;
    } else if (direction === "desc") {
        icon = <ArrowUp className="oct_sortable-header__icon" aria-hidden="true" />;
    }

    return (
        <span className={rootClassName}>
            <span className="oct_sortable-header__label">{label}</span>
            {icon}
        </span>
    );
}

export default SortableHeaderContent;
